import * as Yup from 'yup';

type TranslateFunction = (key: string) => string;

// The new password follows the same rules as on the registration form (RegisterForm.validation).
export const createChangePasswordValidationSchema = (t: TranslateFunction) =>
    Yup.object({
        currentPassword: Yup.string().required(t('myAccountInfo.userDetails.errors.password')),

        newPassword: Yup.string()
            .min(8, t('registerForm.PASSWORD_MIN_LENGTH'))
            .matches(/[A-Z]/, t('registerForm.PASSWORD_UPPERCASE'))
            .matches(/[a-z]/, t('registerForm.PASSWORD_LOWERCASE'))
            .matches(/\d/, t('registerForm.PASSWORD_NUMBER'))
            .required(t('myAccountInfo.userDetails.errors.newPassword')),

        repeatPassword: Yup.string()
            .oneOf([Yup.ref('newPassword')], t('myAccountInfo.userDetails.errors.passwordMatch'))
            .required(t('myAccountInfo.userDetails.errors.repeatPassword')),
    });
